<template>
  <div :class="classes" @dragstart="$emit('dragstart', $event)">
    <div class="m4tag__label" v-if="label">{{ label }}</div>
    <div :class="classesTitle">{{ title }}</div>
    <a class="m4tag__remove" @click="removeTag" v-if="hasClickRemoveListener">
      <m4-icon icon="close"></m4-icon>
    </a>
    <a class="m4tag__remove" :href="removeUrl" v-if="removeUrl">
      <m4-icon icon="close"></m4-icon>
    </a>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "M4Tag",
  props: {
    title: String,
    label: String,
    size: String,
    variant: String,
    removeUrl: String,
    onOnRemoveClick: Function
  },
  emits: ["onRemoveClick", "dragstart"],
  computed: {
    hasClickRemoveListener() {
      return typeof this.$props.onOnRemoveClick === "function";
    },
    classes() {
      let classes = ["m4tag"];
      if (this.size) {
        classes.push("m4tag--" + this.size);
      }
      if (this.variant) {
        classes.push("m4tag--" + this.variant);
      }
      return classes;
    },
    classesTitle() {
      let classes = ["m4tag__title"];
      if (!this.hasClickRemoveListener && !this.removeUrl) {
        classes.push("m4tag__title--no-remove-btn");
      }
      return classes;
    }
  },
  methods: {
    removeTag() {
      this.$emit("onRemoveClick");
    }
  }
};
</script>
